import React from 'react';
import { FieldProps } from 'formik';
import { useTranslation } from '../../../src/i18n';
import Select from '../../molecules/Formik/Select';
import { documentLabelCategories } from '../../../src/constants';

const CategorySelect: React.FC<FieldProps> = ({ field, ...props }) => {
  const { t } = useTranslation();
  return (
    <Select
      field={field}
      defaultLabel={t('category')}
      options={documentLabelCategories.map(key => ({
        id: key,
        name: t(`documentcategory_${key.toLowerCase()}`),
      }))}
      {...props}
    />
  );
};

export default CategorySelect;
